/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useMediaQuery, useTheme } from '@mui/material';

export const useIsExactTablet = () => {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.only('sm'));
};
